export default __webpack_public_path__ + "static/media/permeable-blog-14.306618ec.jpg";